import * as React from 'react';
import { useRef } from 'react';

/** Material UI Packages. */
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';

const SectionBox = ({ title, size, children, sx, labelStyle }) => {
    const boxRef = useRef(null);

    return (
        <Grid size={size}>
            <Typography sx={{ color: '#01354d', fontSize: '13px', fontWeight: 500, mb: 1, ...labelStyle }}>
                {title}
            </Typography>
            <Box
                ref={boxRef}
                sx={{
                    borderRadius: '10px',
                    boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'center',
                    p: 2,
                    gap: '15px',
                    bgcolor: 'white',
                    ...sx,
                }}
            >
                {children}
            </Box>
        </Grid>
    );
};

export default React.memo(SectionBox);
